export default __webpack_public_path__ + "static/media/ICowork.9e016aef.svg";